import type {SVGProps} from 'react';

export function Fa7SolidStrikethrough(props: SVGProps<SVGSVGElement>) {
    return (<svg xmlns="http://www.w3.org/2000/svg" width={"1em"} height={"1em"} viewBox="0 0 640 640" {...props}>
        <path fill="currentColor"
              d="M160 221.5C160 152.2 216.2 96 285.5 96H432c17.7 0 32 14.3 32 32s-14.3 32-32 32H285.5c-34 0-61.5 27.5-61.5 61.5c0 31 23.1 57.2 53.9 61L322 288h222c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h83.1C167 268.6 160 245.8 160 221.5M413.2 400h65.5c.9 6.1 1.4 12.2 1.4 18.5c0 69.3-56.2 125.5-125.5 125.5H208c-17.7 0-32-14.3-32-32s14.3-32 32-32h146.5c34 0 61.5-27.5 61.5-61.5c0-6.4-1-12.7-2.8-18.5"></path>
    </svg>);
}